import { hasQrCodeLink, PostQrCode } from "@package/ui-apollo-components";
import { useSelectorWall } from "@package/ui-redux";
import { MediaDisplay } from "@package/ui-wall-components";
import { FlyoutRelatedPost } from "../../common/RelatedPosts/RelatedPosts";
import { type FlyoutProps } from "../../utils/flyout-props";
import { useFlyoutPostState } from "./PostContextProvider/context-flyout-post";
import { FlyoutPostTitle } from "./PostTitle/PostTitle";

export function FlyoutPostLandscape({ screen }: FlyoutProps) {
  const backgroundColorPrimary =
    screen.flyout?.post?.customData?.primary?.backgroundColor ?? "#909090";
  const backgroundColorSecondary =
    screen.flyout?.post?.customData?.secondary?.backgroundColor ?? "#909090";
  const location = useSelectorWall((state) => state.wall.location);
  const profile = useSelectorWall((state) => state.wall.profile);
  const color = screen.flyout?.post?.customData?.secondary?.color ?? "#ffffff";

  const { assets, idxAsset, incrementAssetIdx, decrementAssetIdx } =
    useFlyoutPostState();

  return (
    <div
      className="flex flex-col w-full h-full"
      style={{ backgroundColor: backgroundColorPrimary }}
    >
      <div className="flex-none w-full">
        <FlyoutPostTitle screen={screen} />
      </div>
      <div className="flex-1 flex-col w-full">
        <div className="relative w-full h-full">
          <div className="flex flex-row w-full h-full">
            <div
              className="relative flex-none h-full max-h-full"
              style={{ maxWidth: "75%" }}
            >
              <MediaDisplay id={assets[idxAsset].media} forceFit />
              <div className="absolute top-0 left-0 w-full h-full">
                <div
                  className="absolute top-0 left-0 h-full w-1/5"
                  onPointerDown={decrementAssetIdx}
                />
                <div
                  className="absolute top-0 right-0 h-full w-1/5"
                  onPointerDown={incrementAssetIdx}
                />
              </div>
            </div>
            <div
              className="flex flex-col grow h-full"
              style={{ backgroundColor: backgroundColorSecondary, color }}
            >
              <div className="grow p-4 w-full text-4xl">
                {assets[idxAsset].body}
              </div>
              <div className="flex-0 w-full p-4">
                <div className="flex flex-row w-full">
                  <div className="flex-none">
                    {hasQrCodeLink(location, profile, screen?.flyout?.post) && (
                      <PostQrCode
                        location={location}
                        profile={profile}
                        post={screen?.flyout?.post}
                        size={172}
                      />
                    )}
                  </div>
                  <div className="flex-1 flex justify-center items-center">
                    <div className="text-4xl pl-4 font-bold text-center">
                      {screen.flyout?.post?.qrCodeText ?? "SCAN FOR DETAILS"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-none w-full">
        <FlyoutRelatedPost screen={screen} />
      </div>
    </div>
  );
}
